// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"665":"94e6fb130e1d09ad","828":"595123ebf8a9a083"}[chunkId] + ".js";
};